import React from 'react'
import { useTranslation } from 'react-i18next'
import * as PropTypes from 'prop-types'
import { Typography } from 'antd'
import { useUser } from '../../context/userContext'
import CurrencyIcon from './formFields/CurrencyIcon'

const { Text } = Typography

const languageFormat = {
  ar: 'en-US',
  en: 'en-US',
  fr: 'fr-FR',
  it: 'it-IT',
  nl: 'nl-NL'
}

const MoneyFormat = ({
  amount = 0,
  title,
  status,
  large,
  percentage,
  extra,
  noFormat,
  small,
  column,
  hideTitle,
  appearance = 'default',
  noWrap,
  category,
  currency
}) => {
  const { user } = useUser()
  const { i18n } = useTranslation()

  const options = {
    style: 'currency',
    currency: currency || user?.company?.currency || 'USD',
    minimumFractionDigits: (amount * 100) % 100 === 0 ? 0 : 2
  }

  const formatted = () => {
    let fixedAmount = amount

    if (fixedAmount && fixedAmount < 0.001 && fixedAmount > -0.001) {
      fixedAmount = 0
    }

    try {
      const formatter = new Intl.NumberFormat(languageFormat[i18n.language] || 'en-US', options)
      return formatter.formatToParts(fixedAmount)
    } catch (e) {
      return [
        {
          type: 'fraction',
          value: fixedAmount - Math.floor(fixedAmount) ? Number((fixedAmount - Math.floor(fixedAmount)).toFixed(2) * 100) : ''
        },
        { type: 'integer', value: Math.floor(fixedAmount) },
        { type: 'currency', value: currency || user.company.currency }
      ]
    }
  }

  const formattedAmount = formatted()
  const isSaudi = (currency || user?.company?.currency) === 'SAR'

  const textType = status === 'danger' ? 'danger' : status === 'warning' ? 'warning' : status === 'success' ? 'success' : undefined
  const containerStyle = {
    display: 'flex',
    flexDirection: column ? 'column' : 'row',
    alignItems: column ? 'center' : 'baseline',
    flexWrap: noWrap ? 'nowrap' : 'wrap',
    margin: small ? '2px 0' : '5px 0'
  }

  const contentStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    marginLeft: 4,
    marginRight: 4
  }

  const supStyle = {
    fontSize: '0.75em',
    verticalAlign: 'super'
  }

  const subStyle = {
    fontSize: '0.75em',
    verticalAlign: 'sub'
  }

  return (
    <div style={containerStyle}>
      {!hideTitle && title ? (
        <Text
          type={textType}
          strong={large}
          style={{ marginBottom: column ? 8 : 0, fontSize: small ? '0.85em' : '1em' }}
        >
          {title}
          {!column ? ': ' : ''}
        </Text>
      ) : null}
      <div style={contentStyle}>
        {isSaudi && !noFormat && i18n.language !== 'ar' ? (
           <span style={{ marginRight: 4 }}><CurrencyIcon /></span>
        ) : (!noFormat || i18n.language === 'ar') &&
          formattedAmount.find(f => f.type === (i18n.language === 'ar' ? 'fraction' : 'currency'))?.value ? (
          <Text type={textType} style={supStyle}>
            &nbsp;
            {formattedAmount.find(f => f.type === (i18n.language === 'ar' ? 'fraction' : 'currency'))?.value}
            &nbsp;
          </Text>
        ) : null}
        <Text type={textType} strong={large} style={{ fontSize: small ? '0.85em' : '1em' }}>
          {noFormat && !Number(amount)
            ? amount
            : formattedAmount
                .filter(f => f.type === 'integer' || f.type === 'group' || f.type === 'minusSign')
                .map(f => f.value)
                .join('')}
        </Text>

        {(!noFormat || i18n.language !== 'ar') &&
        formattedAmount.find(f => f.type === (i18n.language === 'ar' ? 'currency' : 'fraction'))?.value ? (
          <Text type={textType} style={supStyle}>
            &nbsp;
            {formattedAmount.find(f => f.type === (i18n.language === 'ar' ? 'currency' : 'fraction'))?.value}
            &nbsp;
          </Text>
        ) : null}

        {percentage || percentage === 0 ? (
          <Text type="secondary" style={subStyle}>
            &nbsp; ({Number(percentage) ? Number(percentage.toFixed(2)) : percentage}%) &nbsp;
          </Text>
        ) : null}
        {extra || null}
      </div>
    </div>
  )
}

MoneyFormat.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  percentage: PropTypes.number,
  title: PropTypes.string,
  status: PropTypes.string,
  large: PropTypes.bool,
  hideTitle: PropTypes.bool,
  noFormat: PropTypes.bool,
  noWrap: PropTypes.bool,
  small: PropTypes.bool,
  extra: PropTypes.object,
  column: PropTypes.bool,
  currency: PropTypes.string,
  appearance: PropTypes.string,
  category: PropTypes.string
}

export default MoneyFormat
